var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-popover',{attrs:{"popper-class":"cron-popover"},model:{value:(_vm.cronPopover),callback:function ($$v) {_vm.cronPopover=$$v},expression:"cronPopover"}},[_c('iv-cron-classic',_vm._g(_vm._b({on:{"close":function($event){_vm.cronPopover = false},"text":_vm.doText}},'iv-cron-classic',{ ..._vm.$attrs, ..._vm.$props, expression: _vm.innateValue },false),{
            ..._vm.$listeners,
            change: ($event) => (_vm.innateValue = $event),
        })),_c('el-input',_vm._b({attrs:{"slot":"reference"},on:{"input":function($event){_vm.cronPopover = true}},slot:"reference"},'el-input',{
            ..._vm.$attrs,
            ..._vm.$props,
            class: _vm.customInputClasses,
            value: _vm.text,
            title: _vm.text,
            placeholder: _vm.$_(_vm.placeholder),
            readonly: true,
        },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }